import React, { useContext } from "react";
import LiquidGauge from "react-liquid-gauge";
import { Box, Card, Grid, Typography, Divider } from "@mui/material";
import clienteAxios from "../../config/axios";
import AlertaContext from "../../Context/Alerta/AlertaContext";
const getTotalesTanque = async (codigoCombustible) => {
  try {
    // Realizar la solicitud al endpoint
    const response = await clienteAxios.get(
      "/abastecimientos/totales_anual_mensual_semanal_diara"
    );
    console.log({ response, codigoCombustible });

    const totales = response.data;

    const totalDiario = totales.total_diario.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );
    const totalSemanal = totales.total_semanal.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );
    const totalMensual = totales.total_mensual.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );
    const totalAnual = totales.total_anual.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );

    // Verificar si hay datos para el código de combustible
    if (
      totalDiario.length === 0 &&
      totalSemanal.length === 0 &&
      totalMensual.length === 0 &&
      totalAnual.length === 0
    ) {
      return {
        error: true,
      };
    }

    // Retornar los datos filtrados
    return {
      totalDiario,
      totalSemanal,
      totalMensual,
      totalAnual,
    };
  } catch (error) {
    console.error("Error al obtener los totales del tanque:", error.message);
    return {
      error: true,
      totalDiario: [],
      totalSemanal: [],
      totalMensual: [],
      totalAnual: [],
    };
  }
};
export const Liquid = ({ tanque, setdataTotales }) => {
  const {
    tanque: numeroTanque,
    volumen,
    vacio,
    temperatura,
    agua,
    timestamp_dispositivo,
  } = tanque;

  const { mostrarAlerta } = useContext(AlertaContext);
  const volumenTotal = volumen + vacio;
  const porcentajeLlenado = ((volumen / volumenTotal) * 100).toFixed(2);

  // Obtener color según el tanque
  const getColorForProducto = (tanque) => {
    if (tanque === 3) return "#FFD700"; // Amarillo para DIESEL
    if (tanque === 2) return "#00BFFF"; // Azul claro para EXTRA
    if (tanque === 1) return "#708090"; // Gris azulado para SUPER
    return "#A9A9A9"; // Gris predeterminado
  };

  const color = getColorForProducto(numeroTanque);
  const tanqueLabel =
    numeroTanque === 1
      ? "SUPER"
      : numeroTanque === 2
      ? "EXTRA"
      : numeroTanque === 3
      ? "DIESEL"
      : "DESCONOCIDO";

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card
        elevation={5}
        sx={{
          padding: "1rem",
          borderRadius: "15px",
          backgroundColor: "#ffffff",
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
        }}
        onClick={async () => {
          console.log("hola");

          const res = await getTotalesTanque(
            String(numeroTanque === 1 ? 58 : numeroTanque === 2 ? 57 : 59)
          );
          if (res.error) {
            return mostrarAlerta(
              "Hubo un error al obtener los datos del tanque",
              "error"
            );
          }

          setdataTotales({
            ...res,
            nombreCombustible:
              numeroTanque === 1
                ? "GASOLINA SUPER"
                : numeroTanque === 2
                ? "GASOLINA EXTRA"
                : "DIESEL PREMIUM",
          });
        }}
      >
        {/* Indicador circular con opacidad */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) scale(0.8)", // Escalado para ajustar tamaño
            opacity: 0.2, // Opacidad para el fondo
            zIndex: 1,
          }}
        >
          <LiquidGauge
            value={porcentajeLlenado}
            radius={60}
            textSize={1}
            textRenderer={() => null} // Ocultar el texto del medidor
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={3}
            gradient
            gradientStops={[
              { key: "0%", stopColor: color, stopOpacity: 1, offset: "0%" },
              {
                key: "100%",
                stopColor: color,
                stopOpacity: 0.8,
                offset: "100%",
              },
            ]}
            circleStyle={{
              fill: color,
            }}
            waveStyle={{
              fill: color,
            }}
          />
        </Box>

        {/* Contenido encima del fondo */}
        <Box
          sx={{
            position: "relative",
            zIndex: 2, // Asegurar que el contenido esté encima del fondo
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#000",
              }}
            >
              {porcentajeLlenado}%
            </Typography>
          </Box>
          {/* Información del tanque */}
          <Typography variant="h6" align="center" gutterBottom>
            {tanqueLabel}
          </Typography>
          <Divider sx={{ marginY: "0.5rem" }} />
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Volumen Actual:</strong>
            </Typography>
            <Typography variant="body2">{volumen.toFixed(2)} G</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Volumen Vacío:</strong>
            </Typography>
            <Typography variant="body2">{vacio.toFixed(2)} G</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Temperatura:</strong>
            </Typography>
            <Typography variant="body2">{temperatura.toFixed(2)} °C</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Agua:</strong>
            </Typography>
            <Typography variant="body2">{agua.toFixed(2)} G</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Capacidad:</strong>
            </Typography>
            <Typography variant="body2">
              {(volumen + vacio).toFixed(2)} G
            </Typography>
          </Box>{" "}
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              <strong>Fecha:</strong>
            </Typography>
            <Typography variant="body2">
              {new Date(timestamp_dispositivo).toLocaleString("es-ES", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};
